import { useState, useEffect } from 'react';

const ObjectiveCell = ({ objective, onUpdate }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [inputValue, setInputValue] = useState(objective === null ? '' : objective.toString());

    // Update local state when objective prop changes
    useEffect(() => {
        setInputValue(objective === null ? '' : objective.toString());
    }, [objective]);

    const handleSave = () => {
        const numValue = inputValue === '' ? null : parseFloat(inputValue);
        onUpdate(numValue);
        setIsEditing(false);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSave();
        } else if (e.key === 'Escape') {
            setInputValue(objective === null ? '' : objective.toString());
            setIsEditing(false);
        }
    };

    return (
        <td onClick={() => setIsEditing(true)} style={{ cursor: 'pointer' }}>
            {isEditing ? (
                <input
                    type="number"
                    step="0.01"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onBlur={handleSave}
                    autoFocus
                    onKeyDown={handleKeyDown}
                    style={{ width: '100%' }}
                />
            ) : (
                objective !== null ? objective : "Click to set"
            )}
        </td>
    );
};

export default ObjectiveCell;